import {MatricularCurso as Matricula} from 'containers/Matricula/MatricularCurso'

export default function MatricularCurso() {
  return (
    <Matricula />
  );
}
